// Anmeldung (neue Oberfläche): Anmelden, Registrieren, Passwort vergessen, Google. Ziel per ?next= (geprüft).
import '../ui/index.css';
import './login.css';
import { html, attrs, render as put } from '../ui/core/h.js';
import { on } from '../ui/core/dom.js';
import { installRipple } from '../ui/core/ripple.js';
import { initTheme } from '../ui/theme/theme.js';
import { t } from '../shared/i18n.js';
import { safeNext, authError } from './next.js';

initTheme();
installRipple();
const L = (k, v) => t('app2.lg.' + k, v);
const qs = new URLSearchParams(location.search);
const target = safeNext(qs.get('next'));
const st = { mode: qs.get('mode') === 'register' ? 'register' : 'login', busy: false, msg: null };
try { if (!qs.get('mode') && !localStorage.getItem('vc-registered')) st.mode = 'register'; } catch {}
const ERR = { invalid_link: 'auth.err_invalid_link', login_failed: 'auth.err_login_failed' };
if (qs.get('error')) st.msg = { err: true, text: t(ERR[qs.get('error')] || 'auth.err_generic') };

// Zusatzattribute als Objekt über attrs() — ein Text würde von html`` escaped und käme kaputt an (autocomplete="&quot;email&quot;").
const field = (name, label, type, extra = {}) => html`<label class="vc-field"><input name="${name}" type="${type}" placeholder=" "${attrs({ required: true, ...extra })}><span class="vc-field-label">${label}</span></label>`;

function formTpl() {
  if (st.mode === 'forgot') return html`<form data-lg-form="forgot" novalidate>
    <p class="t-body-m">${L('forgot_intro')}</p>
    ${field('email', L('email'), 'email', { autocomplete: 'email', inputmode: 'email' })}
    <button type="submit" class="vc-btn is-m lg-submit"${attrs({ disabled: st.busy })}>${L('forgot_submit')}</button>
    <button type="button" class="vc-btn is-text" data-lg-mode="login"><span class="vc-icon" aria-hidden="true">arrow_back</span>${L('back_to_login')}</button>
  </form>`;
  const reg = st.mode === 'register';
  return html`<div class="vc-chips lg-tabs" role="toolbar" aria-label="${L('title_' + st.mode)}">
      ${['login', 'register'].map((m) => html`<button type="button" class="vc-chip" data-lg-mode="${m}" aria-pressed="${st.mode === m}">${L('tab_' + m)}</button>`)}
    </div>
    <a class="vc-btn is-outlined is-m lg-google" href="/auth/google"><span class="lg-g" aria-hidden="true">G</span>${L('google')}</a>
    <p class="lg-or t-label-l t-muted"><span>${L('or')}</span></p>
    <form data-lg-form="${st.mode}" novalidate>
      ${reg ? field('name', L('name'), 'text', { autocomplete: 'name', minlength: 2, maxlength: 80 }) : ''}
      ${field('email', L('email'), 'email', { autocomplete: 'email', inputmode: 'email' })}
      <div class="vc-field-wrap">${field('password', reg ? L('password_new') : L('password'), 'password', reg ? { autocomplete: 'new-password', minlength: 6 } : { autocomplete: 'current-password' })}
        <button type="button" class="vc-icon-btn lg-eye" data-lg-eye aria-label="${L('show_password')}" aria-pressed="false"><span class="vc-icon" aria-hidden="true">visibility</span></button></div>
      <button type="submit" class="vc-btn is-m lg-submit"${attrs({ disabled: st.busy })}>${reg ? L('register_submit') : L('login_submit')}</button>
      ${reg ? html`<p class="t-body-s t-muted">${L('terms_pre')} <a href="/legal/agb.html">${L('terms')}</a> · <a href="/legal/datenschutz.html">${L('privacy')}</a></p>`
        : html`<button type="button" class="vc-btn is-text" data-lg-mode="forgot">${L('forgot_link')}</button>`}
    </form>`;
}

function draw() {
  put(document.getElementById('app'), html`<main class="lg">
    <section class="lg-card" aria-labelledby="lg-title">
      <a class="lg-brand" href="/?landing=1"><span class="vc-icon" aria-hidden="true">camping</span>ViaCamp</a>
      <h1 id="lg-title" class="t-headline-small">${L('title_' + st.mode)}</h1>
      ${st.msg ? html`<p class="lg-msg${st.msg.err ? ' is-error' : ''}" role="${st.msg.err ? 'alert' : 'status'}">${st.msg.text}</p>` : ''}
      ${formTpl()}
    </section>
    <footer class="lg-foot t-body-s"><a href="/legal/impressum.html">${L('imprint')}</a><a href="/legal/datenschutz.html">${L('privacy')}</a></footer>
  </main>`);
  const first = document.querySelector('[data-lg-form] input');
  if (first && document.activeElement === document.body) first.focus({ preventScroll: true });
}

async function post(url, body) {
  const res = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  let data = null;
  try { data = await res.json(); } catch {}
  return { res, data };
}

async function submit(form) {
  const kind = form.dataset.lgForm;
  const v = Object.fromEntries(new FormData(form).entries());
  for (const el of form.querySelectorAll('input')) el.setAttribute('aria-invalid', String(!el.checkValidity()));
  const bad = form.querySelector('input[aria-invalid="true"]');
  if (bad) { bad.focus(); return; }
  st.busy = true; st.msg = null;
  form.querySelector('.lg-submit').disabled = true;
  try {
    if (kind === 'forgot') {
      const { res, data } = await post('/auth/forgot-password', { email: v.email.trim() });
      st.msg = res.ok ? { err: false, text: (data && data.message) || t('auth.forgot_sent') } : { err: true, text: authError(res.status, data, t('auth.forgot_failed'), t('auth.err_rate_limited')) };
    } else {
      const body = kind === 'register' ? { name: v.name.trim(), email: v.email.trim(), password: v.password } : { email: v.email.trim(), password: v.password };
      const { res, data } = await post(kind === 'register' ? '/auth/register' : '/auth/login', body);
      if (res.ok) {
        try { localStorage.setItem('vc-registered', '1'); } catch {}
        location.replace(target);
        return;
      }
      st.msg = { err: true, text: authError(res.status, data, t(kind === 'register' ? 'auth.register_failed' : 'auth.login_failed'), t('auth.err_rate_limited')) };
    }
  } catch {
    st.msg = { err: true, text: t('auth.connection_error') };
  }
  st.busy = false;
  const keep = kind !== 'forgot' || st.msg.err ? Object.fromEntries(new FormData(form).entries()) : {};
  draw();
  const f = document.querySelector('[data-lg-form]');
  if (f) for (const [k, val] of Object.entries(keep)) if (k !== 'password' && f.elements[k]) f.elements[k].value = val;
  const m = document.querySelector('.lg-msg'); if (m) m.focus?.();
}

on(document, 'click', '[data-lg-mode]', (e, b) => { st.mode = b.dataset.lgMode; st.msg = null; draw(); document.querySelector('[data-lg-form] input')?.focus(); });
on(document, 'click', '[data-lg-eye]', (e, b) => {
  const i = b.parentElement.querySelector('input'); const show = i.type === 'password';
  i.type = show ? 'text' : 'password'; b.setAttribute('aria-pressed', String(show));
  b.setAttribute('aria-label', show ? L('hide_password') : L('show_password')); b.querySelector('.vc-icon').textContent = show ? 'visibility_off' : 'visibility';
});
on(document, 'submit', '[data-lg-form]', (e, f) => { e.preventDefault(); if (!st.busy) submit(f); });
draw();
